<p>deleted-order-details works!</p>
